// Task detail (E7.2), owned by hand: the loader warms the task through the same queryOptions the screen reads.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { taskQuery } from '../../../../../features/tasks/queries'
import { TaskDetail } from '../../../../../features/tasks/TaskDetail'
import { Part } from '../../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/tasks/$taskId/')({
  staticData: { screenId: 'TaskDetailScreen', access: 'task.read' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    await queryClient.ensureQueryData(taskQuery(membership.orgId, params.taskId))
    return { orgId: membership.orgId }
  },
  component: TaskDetailScreen,
})

function TaskDetailScreen() {
  const { orgId } = Route.useLoaderData()
  const params = Route.useParams()
  return (
    <main data-testid={ids.taskDetail.root}>
      <Part testId={ids.taskDetail.skeleton}>
        <TaskDetail orgId={orgId} orgSlug={params.orgSlug} taskId={params.taskId} />
      </Part>
    </main>
  )
}
